export async function imageCompletionSource(context) {
  const match = context.matchBefore(/\[#i\s+[\w-]*/)
  if (!match) return null
  if (match.from === match.to && !context.explicit) return null

  const prefix = "[#i "
  // match.text contains the full matched string
  const query = match.text.slice(prefix.length)

  try {
    const res = await fetch(`/api/v1/autocomplete/images.json?query=${encodeURIComponent(query)}`, {
      headers: {
        "content-type": "application/json"
      }
    })
    const json = await res.json()

    return {
      from: match.from + prefix.length,
      options: json["images"].map(img => ({
        label: img.alias,
        info: () => {
          const div = document.createElement("div")
          div.innerHTML = `<img alt="${img.alias}" src="${img.thumb}" style="max-width:200px; max-height:100px;" />`
          return div
        },
        type: "image"
      }))
    }
  } catch(err) {
    if (err.name !== "AbortError") throw err
  }
}
